export const avatarGenerator = (name) => {
    name = name.replaceAll(" ", "+");
    return `https://ui-avatars.com/api/?name=${name}&rounded=true&bold=true&background=192a56&color=ffffff`;
};

export const requestDefaultGenerator = (
    initialRequest,
    addToInitialRequest
) => {
    Object.keys(addToInitialRequest).forEach((key) => {
        if (!!addToInitialRequest[key]) {
            Object.assign(initialRequest, {
                [key]: addToInitialRequest[key],
            });
        }
    });
    return initialRequest;
};

export const toAbsoluteURL = (pathname) => process.env.PUBLIC_URL + pathname;

export const toServerURL = (pathname) =>
    process.env.REACT_APP_BASEURL_API + "/" + pathname;
